module.exports = __webpack_public_path__ + "static/media/computer-coffee.dfb3bb8e.jpg";